import { appBuildTime, appVersion } from '@/shared/config/version'

/** Unobtrusive build label pinned to a pane corner (login/auth screens). */
export function AppVersion() {
  return (
    <span className='ramp-app-version' title={`Built ${appBuildTime}`}>
      v{appVersion}
    </span>
  )
}
